import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import estateImage from '../../assets/esetate.jpg';

const BRAND = {
  cyan: '#00AEEF',
  magenta: '#EC008C',
  red: '#ED1C24',
};

const BRAND_COLORS = [BRAND.cyan, BRAND.magenta, BRAND.red, BRAND.cyan];

export const newPropertiesData = [
  {
    id: 1,
    image: estateImage,
    price: '₹ 15.44 L',
    title: 'MHADA Code 270D',
    builder: 'Sai Enforcement And Security Pvt. Ltd',
    location: 'Shirdhon, Kalyan',
    type: '1 BHK',
    description:
      'Authorized MHADA project offering a 1 BHK flat with a 321.84 sq.ft. carpet area in Shirdhon, Kalyan. The total cost of ₹15,44,756 includes the sale price, registration charges, and legal fees. 90% bank loan assistance is available with just 10% own funding required.',
  },
  {
    id: 2,
    image: estateImage,
    price: '₹ 19.85 L',
    title: 'MHADA Code 385',
    builder: 'Sai Enforcement And Security Pvt. Ltd',
    location: 'Shirdhon, Kalyan',
    type: '1 BHK',
    description:
      'Authorized MHADA project offering a 1 BHK flat with a 321.84 sq.ft. carpet area in Shirdhon, Kalyan. The total cost of ₹19,85,168 includes the sale price, registration charges, and legal fees. 90% bank loan assistance is available with full documentation support.',
  },
  {
    id: 3,
    image: estateImage,
    price: '₹ 18.21 L',
    title: 'MHADA Code 279',
    builder: 'Sai Enforcement And Security Pvt. Ltd',
    location: 'Khoni, Kalyan',
    type: '1 BHK',
    description:
      'Authorized MHADA project offering a 1 BHK flat with a 321.72 sq.ft. carpet area in Khoni, Kalyan. The total cost of ₹18,21,884 includes the sale price, registration charges, and legal fees. Benefit from transparent cost breakdowns and end-to-end booking support.',
  },
  {
    id: 4,
    image: estateImage,
    price: '₹ 19.67 L',
    title: 'MHADA Code 384',
    builder: 'Sai Enforcement And Security Pvt. Ltd',
    location: 'Khoni, Kalyan',
    type: '1 BHK',
    description:
      'Authorized MHADA project offering a 1 BHK flat with a 321.72 sq.ft. carpet area in Khoni, Kalyan. The total cost of ₹19,67,826 includes the sale price, registration charges, and legal fees. Direct MHADA scheme allocation with no resale margin.',
  },
];

// Cards shown on the home page (two representative projects)
const featuredProjects = [
  {
    id: 1,
    image: estateImage,
    price: '₹ 15.44 L',
    pricePerSqft: '₹ 4,800/sq.ft',
    title: 'MHADA Shirdhon',
    builder: 'Sai Enforcement And Security Pvt. Ltd',
    location: 'Shirdhon, Kalyan',
    type: '1 BHK',
    carpet: '321.84 sq.ft',
    bath: '1 Bath',
    status: 'Under Construction',
    possession: 'Dec 2026',
    downPayment: '₹ 1.54 L',
    emi: '₹ 12,400/mo',
    progress: 70,
    highlights: ['No Brokerage', '90% Loan', 'Direct MHADA'],
  },
  {
    id: 2,
    image: estateImage,
    price: '₹ 18.21 L',
    pricePerSqft: '₹ 5,660/sq.ft',
    title: 'MHADA Khoni',
    builder: 'Sai Enforcement And Security Pvt. Ltd',
    location: 'Khoni, Kalyan',
    type: '1 BHK',
    carpet: '321.72 sq.ft',
    bath: '1 Bath',
    status: 'Under Construction',
    possession: 'Dec 2026',
    downPayment: '₹ 1.82 L',
    emi: '₹ 14,600/mo',
    progress: 55,
    highlights: ['No Brokerage', '90% Loan', 'Direct MHADA'],
  },
];

const MapPinIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const BedIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8" />
    <path d="M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
    <path d="M12 4v6" />
    <path d="M2 18h20" />
  </svg>
);

const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1">
    <path d="M7 7h10v10" />
    <path d="M7 17 17 7" />
  </svg>
);

const AreaIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 3 3 21" />
    <path d="M21 8V3h-5" />
    <path d="M3 16v5h5" />
  </svg>
);

const BathIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 4 8 6" />
    <path d="M17 19v2" />
    <path d="M2 12h20" />
    <path d="M7 19v2" />
    <path d="M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" />
  </svg>
);

const CheckIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 2v4" /><path d="M16 2v4" /><rect width="18" height="18" x="3" y="4" rx="2" /><path d="M3 10h18" />
  </svg>
);

const ShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
  </svg>
);

const PropertyCard = ({ property, index, isVisible, accent }) => {
  const handleWhatsApp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const whatsappNumber = '919702850777';
    const message = `Hello Sai Enforcement And Security Pvt. Ltd.!%0A%0AI'm interested in *${property.title}* (${property.type} · ${property.price}) at ${property.location}.%0A%0APlease share more details.`;
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <Link
      to={`/property/${property.id}`}
      className={`about-reveal group relative block w-full ${isVisible ? 'about-visible' : ''}`}
      style={{ transitionDelay: `${index * 120}ms` }}
    >
      <div className="relative rounded-[1.5rem] p-[2px] ses-brand-gradient transition-all duration-500 group-hover:-translate-y-2 group-hover:shadow-2xl group-hover:shadow-slate-300/50">
        <div className="relative overflow-hidden rounded-[1.4rem] bg-white">
          {/* Image */}
          <div className="relative h-[210px] overflow-hidden">
            <img
              alt={property.title}
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              src={property.image}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/10 to-transparent" />

            {/* Top badges */}
            <div className="absolute top-3 left-3 right-3 flex items-start justify-between gap-2">
              <span
                className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white backdrop-blur-md shadow-sm"
                style={{ background: `${accent}e6` }}
              >
                <span className="relative flex h-1.5 w-1.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60" />
                  <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-white" />
                </span>
                MHADA
              </span>
              <span className="inline-flex items-center gap-1 rounded-full bg-white/90 backdrop-blur-md px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-emerald-600 shadow-sm">
                <ShieldIcon />
                RERA
              </span>
            </div>

            {/* Status + possession */}
            <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between gap-2">
              <div>
                <p className="text-[10px] font-semibold uppercase tracking-wider text-white/70">Starting from</p>
                <p className="text-xl font-black text-white leading-tight drop-shadow">{property.price}</p>
                <p className="text-[10px] text-white/70 mt-0.5">{property.pricePerSqft}</p>
              </div>
              <span className="inline-flex items-center gap-1 rounded-lg bg-white/90 backdrop-blur-md px-2 py-1 text-[10px] font-bold text-slate-700 shadow-sm">
                <CalendarIcon />
                {property.possession}
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="p-5">
            {/* Title + location */}
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <h3 className="text-lg font-extrabold text-slate-900 leading-snug transition-colors group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-[#00AEEF] group-hover:to-[#EC008C]">
                  {property.title}
                </h3>
                <p className="mt-1 inline-flex items-center gap-1.5 text-xs text-slate-500">
                  <MapPinIcon color={accent} />
                  {property.location}
                </p>
              </div>
              <div
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-white opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
                style={{ background: `linear-gradient(135deg, ${BRAND.cyan}, ${BRAND.magenta})` }}
              >
                <ArrowIcon />
              </div>
            </div>

            {/* Spec row */}
            <div className="mt-4 grid grid-cols-3 rounded-xl border border-slate-100 bg-slate-50/70 divide-x divide-slate-100 overflow-hidden">
              <div className="flex flex-col items-center justify-center py-2.5 px-1">
                <BedIcon color={accent} />
                <p className="mt-1 text-xs font-bold text-slate-900">{property.type}</p>
                <p className="text-[9px] text-slate-400 uppercase tracking-wide">Config</p>
              </div>
              <div className="flex flex-col items-center justify-center py-2.5 px-1">
                <AreaIcon color={accent} />
                <p className="mt-1 text-xs font-bold text-slate-900">{property.carpet.replace(' sq.ft', '')}</p>
                <p className="text-[9px] text-slate-400 uppercase tracking-wide">Sq.ft</p>
              </div>
              <div className="flex flex-col items-center justify-center py-2.5 px-1">
                <BathIcon color={accent} />
                <p className="mt-1 text-xs font-bold text-slate-900">{property.bath.replace(' Bath', '')}</p>
                <p className="text-[9px] text-slate-400 uppercase tracking-wide">Bath</p>
              </div>
            </div>

            {/* Payment mini-stats */}
            <div className="mt-3 grid grid-cols-2 gap-2">
              <div className="rounded-xl border border-slate-100 px-3 py-2">
                <p className="text-[9px] text-slate-400 uppercase tracking-wide font-semibold">Down Payment</p>
                <p className="text-sm font-black text-slate-900">{property.downPayment}</p>
              </div>
              <div className="rounded-xl border border-slate-100 px-3 py-2">
                <p className="text-[9px] text-slate-400 uppercase tracking-wide font-semibold">EMI from</p>
                <p className="text-sm font-black ses-brand-text">{property.emi}</p>
              </div>
            </div>

            {/* Highlights */}
            <div className="mt-3 flex flex-wrap gap-1.5">
              {property.highlights.map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-semibold border"
                  style={{ color: accent, borderColor: `${accent}33`, background: `${accent}0d` }}
                >
                  <CheckIcon color={accent} />
                  {tag}
                </span>
              ))}
            </div>

            {/* Construction progress */}
            <div className="mt-4">
              <div className="flex items-center justify-between text-[10px] font-semibold mb-1">
                <span className="text-slate-400 uppercase tracking-wide">{property.status}</span>
                <span style={{ color: accent }}>{property.progress}% Complete</span>
              </div>
              <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
                <div
                  className="h-full rounded-full ses-brand-gradient transition-all duration-1000 ease-out"
                  style={{ width: isVisible ? `${property.progress}%` : '0%' }}
                />
              </div>
            </div>

            {/* Footer */}
            <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between gap-3">
              <div className="flex items-center gap-2 min-w-0">
                <div
                  className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-white text-xs font-black"
                  style={{ background: `linear-gradient(135deg, ${BRAND.cyan}, ${BRAND.magenta})` }}
                >
                  SES
                </div>
                <div className="min-w-0">
                  <p className="text-[9px] text-slate-400 leading-none">Posted by</p>
                  <p className="text-[11px] font-semibold text-slate-700 truncate">Sai Enforcement & Security</p>
                </div>
              </div>
              <button
                type="button"
                onClick={handleWhatsApp}
                aria-label="Enquire on WhatsApp"
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-emerald-200 text-emerald-600 bg-emerald-50 hover:bg-emerald-100 transition-colors"
              >
                <WhatsAppIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default function NewProperties() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.12 }
    );

    if (currentRef) observer.observe(currentRef);
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden bg-white py-16 px-4 md:px-10 md:py-24 font-display"
    >
      {/* Light gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-slate-50 to-white pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-72 bg-gradient-to-b from-[#00AEEF]/10 via-[#EC008C]/6 to-transparent pointer-events-none" />
      <div className="absolute top-1/4 -right-20 w-80 h-80 rounded-full bg-[#EC008C]/10 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-1/4 -left-20 w-72 h-72 rounded-full bg-[#00AEEF]/12 blur-[90px] pointer-events-none" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-40 bg-gradient-to-t from-[#ED1C24]/8 to-transparent blur-2xl pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-1 ses-brand-gradient opacity-60" />

      <div className="relative mx-auto max-w-7xl">
        {/* Header */}
        <div
          className={`about-reveal mb-12 md:mb-14 text-center ${isVisible ? 'about-visible' : ''}`}
        >
          <span className="mb-4 inline-flex items-center gap-2 rounded-full p-[1.5px] ses-brand-gradient shadow-sm">
            <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-slate-600">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={BRAND.cyan} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
              </svg>
              MHADA Approved
            </span>
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            Latest{' '}
            <span className="ses-brand-text">MHADA Projects</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-slate-500 leading-relaxed">
            Secure affordable, government-approved 1 BHK homes with full clarity on costs and
            end-to-end booking support.
          </p>

          <div className="mx-auto mt-6 h-1 w-24 rounded-full ses-brand-gradient opacity-80" />
        </div>

        {/* Property grid — two featured projects */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {featuredProjects.map((property, index) => (
            <PropertyCard
              key={property.id}
              property={property}
              index={index}
              isVisible={isVisible}
              accent={BRAND_COLORS[index % BRAND_COLORS.length]}
            />
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div
          className={`about-reveal mt-12 md:mt-16 rounded-3xl p-[2px] ses-brand-gradient shadow-lg ${
            isVisible ? 'about-visible' : ''
          }`}
          style={{ transitionDelay: '500ms' }}
        >
          <div className="rounded-[1.35rem] bg-white px-6 py-5 md:px-8 md:py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-center sm:text-left">
              <p className="text-lg font-bold text-slate-900">
                Not sure which project fits your budget?
              </p>
              <p className="text-sm text-slate-500 mt-1">
                Use our budget calculator above or talk to our experts for personalized guidance.
              </p>
            </div>
            <button
              type="button"
              onClick={() =>
                document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' })
              }
              className="relative shrink-0 overflow-hidden group inline-flex items-center gap-2 rounded-2xl px-7 py-3.5 text-sm font-bold text-white transition-all hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(0,174,239,0.3)]"
            >
              <span className="absolute inset-0 ses-brand-gradient opacity-90 group-hover:opacity-100 transition-opacity" />
              <span className="relative">Get Expert Help</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="relative transition-transform group-hover:translate-x-1">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
